<script setup lang="ts">
import plural from 'plural-ru'

interface StudentCardStudent {
  name: string
  tails_count?: number
  demo?: boolean
  has_pikimoni_binding?: boolean
  needs_pikimoni_binding?: boolean
  can_disconnect_pikimoni?: boolean
  cabinet_url?: string
}

defineProps<{
  student: StudentCardStudent
}>()

defineEmits<{
  (e: 'edit'): void
  (e: 'login:pikimoni'): void
  (e: 'connect:pikimoni'): void
  (e: 'disconnect:pikimoni'): void
  (e: 'open-login-modal'): void
}>()

const pluralize = (num: number, ...forms: [string, string] | [string, string, string]) => plural(num, ...forms)
</script>

<template>
  <section class="student-card pa-2 pa-d-3">
    <header class="student-card__header d-flex justify-space-between align-center">
      <div v-if="!student.demo" class="student-card__avatar" @click="$emit('edit')">
        <v-icon size="32" class="gray-text">mdi-account</v-icon>
      </div>

      <h3 class="student-card__title">{{ student.name }}</h3>

      <ul class="student-card__stats">
        <li>
          <v-icon v-if="student.tails_count" key="red" size="24" class="mr-1"> home-smile-red </v-icon>
          <v-icon v-else key="green" size="24" class="mr-1"> home-smile-green </v-icon>

          {{ (student.tails_count || 0).toLocaleString() }}

          {{ pluralize(student.tails_count ?? 0, 'хвост', 'хвоста', 'хвостов') }}
        </li>
      </ul>

      <button v-if="!student.demo" class="student-card__edit-btn" @click="$emit('edit')">
        <v-icon size="24" class="mr-1 gray-text">mdi-pencil</v-icon>
      </button>
    </header>
    <slot></slot>
    <!-- <div class="student-card__divider py-4"></div> -->
    <div class="flex-spacer" />
    <v-button
      v-if="student.has_pikimoni_binding"
      mode="large primary block"
      class="mt-auto mb-1"
      @click="$emit('login:pikimoni')"
    >
      Войти в Pikimoni
    </v-button>
    <v-button
      v-else-if="student.needs_pikimoni_binding"
      mode="large gradient block"
      class="mt-auto mb-1"
      @click="$emit('connect:pikimoni')"
    >
      Подключиться к Pikimoni
    </v-button>
    <v-button
      v-if="student.can_disconnect_pikimoni"
      mode="large primary block"
      class="mt-auto mb-1"
      @click="$emit('disconnect:pikimoni')"
    >
      Отключиться от Pikimoni
    </v-button>
    <v-button mode="large warn block" target="_blank" :href="student.cabinet_url" class="mt-auto mb-1">
      <v-icon class="mr-1">mdi-open-in-new</v-icon>
      Кабинет ученика
    </v-button>
    <v-button v-if="!student.demo" mode="large primary block" class="mt-auto" @click="() => $emit('open-login-modal')">
      <v-icon class="mr-1">mdi-cellphone</v-icon>
      Войти с другого устройства
    </v-button>
  </section>
</template>

<style lang="scss">
.student-card {
  display: flex;
  flex-direction: column;
  border-radius: 2 * $grid-gap;
  border: 1px solid $lightGray;

  &__header {
    padding: 16px;
    display: grid;
    grid-template-columns: 72px 1fr auto;
    grid-template-rows: auto auto;
    gap: 0 16px;
    grid-template-areas:
      'avatar title edit-btn'
      'avatar stats stats';
  }

  &__avatar {
    grid-area: avatar;
    background: $lightenGray;
    width: 72px;
    height: 72px;
    border-radius: 999px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__stats {
    grid-area: stats;
    display: flex;
    gap: 24px;
    align-items: center;

    li {
      display: flex;
      align-items: center;
    }
  }

  &__edit-btn {
    grid-area: edit-btn;
    cursor: pointer;
  }

  &__title {
    @include text-title;

    font-weight: bold;
  }
}
</style>
